import React, { FC, PropsWithChildren } from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

interface Props extends PropsWithChildren {
  isLoading?: boolean;
}

const RequirementSkeleton: FC<Props> = ({ isLoading = false, children }) => {
  return (
    <>
      {!isLoading ? (
        children
      ) : (
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Skeleton animation="wave" variant="text" width={160} height={21} />
            <Skeleton animation="wave" variant="text" width={35} height={21} />
          </Box>
          <Box mb={5}>
            <Skeleton
              animation="wave"
              variant="text"
              width={'100%'}
              height={20}
            />
          </Box>
          <Box>
            {[1, 2].map(() => (
              <Box mb={5}>
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={130}
                  height={30}
                />
                {[1, 2, 3, 4, 5].map(() => (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                    mb={1}
                  >
                    <Box display="flex" alignItems="center">
                      <Box mr={2}>
                        <Skeleton
                          animation="wave"
                          variant="rect"
                          width={22}
                          height={22}
                        />
                      </Box>
                      <Skeleton
                        animation="wave"
                        variant="rect"
                        width={300}
                        height={22}
                      />
                    </Box>
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width={22}
                      height={22}
                    />
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default RequirementSkeleton;
